import { forwardRef, type ComponentProps } from "react";
import { cn } from "../../lib/utils";
import { X } from "lucide-react";
import { Button } from "../button";

export interface FilePreviewProps extends ComponentProps<"div"> {
  fileName?: string;
  fileType?: string;
  onRemove?: () => void;
  maxWidth?: string;
}

export const FilePreview = forwardRef<HTMLDivElement, FilePreviewProps>(
  ({ fileName, fileType, onRemove, maxWidth = "100px", className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        data-slot="file-preview"
        role="button"
        className={cn(
          "flex flex-col items-center gap-1 text-xs bg-gray-100 rounded-sm relative group",
          !children && "p-2",
          className
        )}
        style={{ maxWidth }}
        {...props}
      >
        {children ? (
          <div className="rounded-sm overflow-hidden">{children}</div>
        ) : (
          <>
            <p className="font-bold text-center truncate w-full">{fileName ?? "Unnamed file"}</p>
            {fileType && <p className="text-muted-foreground">{fileType}</p>}
          </>
        )}
        {onRemove && (
          <Button
            size="sm-icon"
            className="absolute -top-1 -right-1 opacity-0 transition-opacity group-hover:opacity-100 bg-muted-foreground hover:bg-foreground text-background rounded-full w-4 h-4 flex items-center justify-center p-0"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onRemove();
            }}
          >
            <X className="p-0.5" />
          </Button>
        )}
      </div>
    );
  }
);

FilePreview.displayName = "FilePreview";
